import { get, post, put } from '../../api-config';
import { gdpService } from './_service';

export const postWarehouses = async (data: any) =>
  await post(gdpService, '/warehouses/search', data, null);

export const postNewWarehouse = async (data: any) =>
  await post(gdpService, '/warehouses', data, null);

export const getWarehouse = async (id: any) =>
  await get(gdpService, `/warehouses/${id}`, null, null);

export const putWarehouseInfo = (id: any, data: any) =>
  put(gdpService, `/warehouses/${id}`, data, null);
